import { useCallback, useReducer } from "react";

interface MessageExportState {
  isExportingPdf: boolean;
  exportError: string | null;
}

type MessageExportAction =
  | { type: "exportPdfStart" }
  | { type: "exportPdfSuccess" }
  | { type: "exportPdfError"; error: string };

const messageExportInitialState: MessageExportState = {
  isExportingPdf: false,
  exportError: null,
};

const messageExportReducer = (
  state: MessageExportState,
  action: MessageExportAction,
): MessageExportState => {
  switch (action.type) {
    case "exportPdfStart":
      return { isExportingPdf: true, exportError: null };
    case "exportPdfSuccess":
      return { isExportingPdf: false, exportError: null };
    case "exportPdfError":
      return { isExportingPdf: false, exportError: action.error };
    default:
      return state;
  }
};

export const useMessageExportState = () => {
  const [state, dispatch] = useReducer(messageExportReducer, messageExportInitialState);

  const runPdfExport = useCallback(
    async (exportPdf: () => Promise<void>, errorMessage: string) => {
      dispatch({ type: "exportPdfStart" });
      try {
        await exportPdf();
        dispatch({ type: "exportPdfSuccess" });
      } catch {
        dispatch({ type: "exportPdfError", error: errorMessage });
      }
    },
    [],
  );

  return {
    isExportingPdf: state.isExportingPdf,
    exportError: state.exportError,
    runPdfExport,
  };
};
